import Box from '@mui/material/Box';
import { TabPanel } from '@mui/lab';
import { GridColDef } from '@mui/x-data-grid';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';
import Divider from '@mui/material/Divider';
import DataTable from '../../../../../shared/components/Table';
import { useEffect, useState } from 'react';
import { dup } from '../../../../../shared/types/nfe.ts';
import Typography from '@mui/material/Typography/Typography';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';

const COLUMNS: GridColDef[] = [
    {
        field: 'cc_nome',
        headerName: 'Centro de Custo',
        headerAlign: 'center',
        align: 'center',
        width: 700,
    },
    {
        field: 'cc_percentual',
        headerName: 'Percentual (%)',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        valueGetter: (value) => formatCurrency(value, 2, 2)
    }
]

interface TabCentrosCustoProps {
    values: any,
    activeCentroCustoSelected: any;
    CentroCustoOptions: SelectAutoCompleteOptions[];
    handleAutoCompleteSelectedCentroCusto: (value: SelectAutoCompleteOptions) => void;
    handleSearchCentroCusto: (value: string, type: string) => void;
    duploClick?: boolean;
}
export const TabCentrosCusto = ({
    values,
    activeCentroCustoSelected,
    CentroCustoOptions,
    handleSearchCentroCusto,
    handleAutoCompleteSelectedCentroCusto,
    duploClick,
}: TabCentrosCustoProps) => {
    const [fats, setFats] = useState<dup[]>([])

    const handleFats = (dup: dup[]): dup[] => {
        if (dup) {
            if (dup?.length) {
                return dup.map((item: dup, index: number) => {
                    return { ...item, id: index }
                })
            } else {
                // @ts-ignore - .
                return [{ ...dup, id: 1 }]
            }
        }
        return []
    }

    useEffect(() => {
        setFats(handleFats(values?.nfeProc?.NFe?.infNFe?.cobr?.dup))
    }, [values?.nfeProc?.NFe?.infNFe?.cobr?.dup])

    return (
        <TabPanel value='3'>
            <form autoComplete='off' onSubmit={() => console.log('oi')} name='customer-detail'>
                <fieldset disabled={duploClick}>
                    <Box className='grid grid-cols-12 gap-7 pt-4'>
                        <SelectAutoCompleteComponent
                            label={'Centro de Custo *'}
                            value={activeCentroCustoSelected?.cc_descricao ?? ''}
                            className={'col-span-6'}
                            name={'search'}
                            options={CentroCustoOptions}
                            handleSearch={(value: string) =>
                                handleSearchCentroCusto(value, 'centroCusto.cCustoId')
                            }
                            onSelectValue={handleAutoCompleteSelectedCentroCusto}
                        />
                        <Box className='col-span-12 py-4 pt-4'>
                            <div className='flex justify-center'>
                                <Typography variant="h5" component="h2" className='col-span-6 gap-left-8'>
                                    Centros de Custo
                                </Typography>
                            </div>
                            <Divider className={'col-span-12'} />
                            <DataTable
                                hideFooter={true}
                                height={'30vh'}
                                columns={COLUMNS}
                                rows={fats}
                                showFilter={false}
                                showButtonToXlsx={false}
                            />
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </TabPanel>
    )
}